import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Indicators from './views/Indicators'
import Regions from './views/Regions'
import EconomicActivities from './views/EconomicActivities'
import ScianCatalog from './views/ScianCatalog'
import BureauKeys from './views/BureauKeys'
import UrlShortener from './views/UrlShortener'
import SMSApi from './views/SMSApi'
import CreditScore from './views/fira/CreditScore.vue'
import CreditScoreEvaluation from './views/fira/CreditScoreEvaluation.vue'
import LossSeverity from './views/fira/LossSeverity.vue'
import Collateral from './views/fira/Collateral.vue'
import CreditRiskRating from './views/fira/CreditRiskRating.vue'
import InegiStates from './views/inegi/States.vue'
import InegiMunicipalities from './views/inegi/Municipalities.vue'
import InegiLocations from './views/inegi/Locations.vue'
import InegiGeostatisticsCode from './views/inegi/GeostatisticsCode.vue'
import SepomexPaises from './views/sepomex/Paises.vue'
import SepomexEstados from './views/sepomex/Estados.vue'
import SepomexMunicipios from './views/sepomex/Municipios.vue'
import SepomexCiudades from './views/sepomex/Ciudades.vue'
import SepomexColonias from './views/sepomex/Colonias.vue'
import SepomexCodigosPostales from './views/sepomex/CodigosPostales.vue'
import IdTypes from './views/IdTypes.vue'
import IdIssuers from './views/IdIssuers.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/regions',
            name: 'Regions',
            component: Regions
        },
        {
            path: '/sendSms',
            name: 'SMSApi',
            component: SMSApi
        },
        {
            path: '/indicators',
            name: 'indicators',
            component: Indicators
        },
        {
            path: '/economicActivities',
            name: 'economicActivities',
            component: EconomicActivities
        },
        {
            path: '/urlShortener',
            name: 'urlShortener',
            component: UrlShortener
        },
        {
            path: '/scianCatalog',
            name: 'scianCatalog',
            component: ScianCatalog
        },
        {
            path: '/bureauKeys',
            name: 'bureauKeys',
            component: BureauKeys
        },
        {
            path: '/fira/credit-score',
            name: 'CreditScore',
            component: CreditScore
        },
        ,
        {
            path: '/fira/credit-score-evaluation',
            name: 'CreditScoreEvaluation',
            component: CreditScoreEvaluation
        },
        {
            path: '/fira/loss-severity',
            name: 'LossSeverity',
            component: LossSeverity
        },
        {
            path: '/fira/collateral',
            name: 'Collateral',
            component: Collateral
        },
        {
            path: '/fira/credit-risk-rating',
            name: 'CreditRiskRating',
            component: CreditRiskRating
        },
        {
            path: '/inegi/States',
            name: 'InegiStates',
            component: InegiStates
        },
        {
            path: '/inegi/Municipalities',
            name: 'InegiMunicipalities',
            component: InegiMunicipalities
        },
        {
            path: '/inegi/Locations',
            name: 'InegiLocations',
            component: InegiLocations
        },
        {
            path: '/inegi/GeostatisticsCode',
            name: 'InegiGeostatisticsCode',
            component: InegiGeostatisticsCode
        },
        {
            path: '/sepomex/paises',
            name: 'SepomexPaises',
            component: SepomexPaises
        },
        {
            path: '/sepomex/estados',
            name: 'SepomexEstados',
            component: SepomexEstados
        },
        {
            path: '/sepomex/municipios',
            name: 'SepomexMunicipios',
            component: SepomexMunicipios
        },
        {
            path: '/sepomex/ciudades',
            name: 'SepomexCiudades',
            component: SepomexCiudades
        },
        {
            path: '/sepomex/colonias',
            name: 'SepomexColonias',
            component: SepomexColonias
        },
        {
            path: '/sepomex/codigos-postales',
            name: 'SepomexCodigosPostales',
            component: SepomexCodigosPostales
        },
        {
            path: '/idTypes',
            name: 'idTypes',
            component: IdTypes
        },
        {
            path: '/idIssuers',
            name: 'idIssuers',
            component: IdIssuers
        }
    ]
})

export default router
